// src/store/thunks/user/createNewExternalUserThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { withErrorHandling } from '@/store/thunks/thunkWrappers';
import type { UserService } from '@/services/abstract/UserService';
import type { CreateExternalUserPayload } from '@/types/create-six.types';

export const createNewExternalUserThunk = createAppAsyncThunk<
  string,
  CreateExternalUserPayload
>(
  'user/createNewExternalUser',
  withErrorHandling(
    async(params, thunkApi) => {
      const userService: UserService = thunkApi.extra.userService;
      const newUser = await userService.createNewExternalUser(params);
      return newUser.userId;
    }
  )
);
